import { GridColumnGroupingModel } from '@mui/x-data-grid'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit/types'
import { EmbeddedObjectShort } from '@pages/FormCreateOrEdit/types'

import {
  BIND_TYPE,
  ENTITY_TYPES_REQUEST,
  FIELD_VALUE_FORMAT,
  FIELD_VALUE_TYPE,
  OBJECT_FIELD_TYPE,
  PINNED_COLUMN,
  TYPES_SOURCE_OPTIONS,
  UPDATE_TYPE,
} from '../constants'

import { ActionRow } from './action'
import { ColumnParametersType, GETTabDTO } from './api'
import { CommandParameterDTO } from './command'
import { AutocompleteOption } from './common'
import { DisplayRule } from './displayRule'

export type sortRestrictionType = {
  sortDirection: string
  columnToSort: string
  priority?: string // число
}

/** Ограничения поля, на котором основана колонка */
export type ColumnRestrictions = {
  /** Отображение колонки с данным полем у пользователя */
  show: boolean | string
  /** Ширина колонки с данным полем у пользователя */
  width: number
  /** Порядок колонки с данным полем в таблице у пользователя */
  order: number
  /** Закрепление колонки справа/слева в таблице у пользователя */
  fix: PINNED_COLUMN | null
  /** Примененная к колонке сортировка */
  sort: sortRestrictionType
  /** Разрешен ли быстрый поиск по колонке */
  quickSearchPermission: boolean | string
  /** Дефолтное значение чекбокса быстого поиска */
  quickSearchChoice: boolean | string
}

export type ConfiguredColumn = {
  id: string | number
  internalId: string
  order?: number
  code: string
  title: string
  valueType: FIELD_VALUE_TYPE | null
  bindType?: BIND_TYPE
  fieldType?: OBJECT_FIELD_TYPE
  value: string
  editable: boolean
  actions: ActionRow[]
  objectCode?: string
  objectValue?: string
  columnToSort?: string
  pinnedColumn: PINNED_COLUMN | null
  visibility?: boolean
  parameters?: ColumnParametersType
  restrictions?: ColumnRestrictions
  useLocalParameters?: boolean
  enumDescription?: boolean
  useDisplayRule?: boolean
  displayRule?: DisplayRule | undefined
  displayRuleId?: number | undefined
  valueFormat?: FIELD_VALUE_FORMAT | null
  columnObjectValue?: string | undefined
  formatDate?: string | null
  parameterShowSA?: string | null
  pathArray?: EmbeddedObject[] | null
  isPk?: boolean
  width?: number
  valuePathArray?: EmbeddedObjectShort[]
}

export type EnumCellType = {
  name: string | undefined
  valueType: FIELD_VALUE_TYPE | null
  objectCode: string | undefined
  value: number | boolean | string | AutocompleteOption
  isDialogWindow: boolean
  displayRule?: DisplayRule | undefined
  useDisplayRule?: boolean
}

export type ViewActionObjectParams = {
  formCode: string
  formCodeByFieldValue: FormCodeByFieldValueType[]
}

export type FormCodeByFieldValueType = { field: string; value: string | number; formCode: string }

export enum ENTITY_COMMAND_TYPE {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  GET_ALL = 'GET_ALL',
  GET_BY_ID = 'GET_BY_ID',
  GET_ALL_BY_IDS = 'GET_ALL_BY_IDS',
  GET_BY_INTERNAL_ID = 'GET_BY_INTERNAL_ID',
  GET_ALL_BY_INTERNAL_IDS = 'GET_ALL_BY_INTERNAL_IDS',
}

export const ENTITY_GET_ALL_COMMAND_TYPES = [
  ENTITY_COMMAND_TYPE.GET_ALL,
  ENTITY_COMMAND_TYPE.GET_ALL_BY_IDS,
  ENTITY_COMMAND_TYPE.GET_ALL_BY_INTERNAL_IDS,
]

export const ON_SAVE_FORM_COMMAND_TYPES = [
  ENTITY_COMMAND_TYPE.CREATE,
  ENTITY_COMMAND_TYPE.UPDATE,
  ENTITY_COMMAND_TYPE.DELETE,
]

export type EntityCommandDTO = {
  type: ENTITY_COMMAND_TYPE
  name: string
  objectCode: string
  objectTitle: string
  httpMethod: string
  resource: TYPES_SOURCE_OPTIONS
  parameters: CommandParameterDTO[]
  body: CommandParameterDTO[]
  prepareScript?: string
}

export type EntityType = {
  id: string | number
  code: string
  title: string
  objectCode: string
  objectTitle: string
  columnHeaders: GridColumnGroupingModel
  columns?: ConfiguredColumn[]
  tabs?: GETTabDTO[]
  actions?: ActionRow[]
  commands: EntityCommandDTO[]
  rowBinding?: boolean
  rowBindingType?: string
  rowBindingValue?: string
  rowBindingValueTypeCode?: string
  auditFieldHistory?: boolean
  parameters?: ColumnParametersType
  useLocalParameters?: boolean
  type: ENTITY_TYPES_REQUEST
  hasQuickSearch?: boolean
  hasWrapRowText?: boolean
  headerHeight?: number | null
  headerGroupHeight?: number | null
  hasWrapHeaderText: boolean
  parameterShowSA?: string | null
  prefilter?: string
  updateSetting?: {
    type?: UPDATE_TYPE
    interval?: number
  }
  internalId: string
  editable?: boolean
  multiselection?: boolean
}
